const re_psd = text => /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!"#$%&'()*+,-./:;<=>?@[^_`{|}~\x5C\x5D])[A-Za-z\d!"#$%&'()*+,-./:;<=>?@[^_`{|}~\x5C\x5D]{12,20}$/.test(text);

// const re_account = text => (!/^([a-zA-Z]+\d+|\d+[a-zA-Z]+)[a-zA-Z0-9]*$/.test(text) || (text).length < 6 || (text).length > 20);
const re_account = text => /^[\d|a-zA-Z]{1,100}$/.test(text);

const re_email = text => /[a-z0-9]*@[a-z0-9]*\.[a-z0-9]+/gi.test(text);

const re_num = text => /^[\d]+$/.test(text);

const re_coordinate = text => /^[+-]?\d+(?:\.\d{1,6})?$/.test(text);

export { re_psd, re_account, re_email, re_num, re_coordinate };
